/*
 * author: zero
 * createdTime: 2018/08/01
 * */

/** 登出 - 新接口*/
export const API_LOGOUT = {
  url: 'logout',
  config: {
    method: 'post',
    host: 'usercenter',
  },
};

/** 登陆接口 - 新接口*/
export const API_LOGIN = {
  url: 'login/scc',
  config: {
    method: 'post',
    host: 'usercenter',
    noWarn: true,
  },
};
export const API_LOGIN_DEV = {
  url: 'login/scc',
  config: {
    method: 'post',
    host: 'USERCENTERDEV',
    noWarn: true,
  },
};

/** 获取验证码*/
export const API_POST_USER_CENTER_SMS_CODE = {
  url: 'sms/send/forgetPasswordSMSCodeByTenants',
  config: {
    method: 'get',
    host: 'usercenter', // noWarn: true
  },
};

/** 重置密码*/
export const API_POST_USER_CENTER_RESET_PWD = {
  url: 'users/forgetPwd',
  config: {
    method: 'post',
    host: 'usercenter',
  },
};

/** 验证验证码*/
export const API_POST_VERIFICATION_CODE_CHECK = {
  url: 'sms/check/forgetPasswordSMSCode',
  config: {
    method: 'get',
    host: 'usercenter',
  },
};

/** 忘记密码修改*/
export const API_POST_USER_CENTER_GET_BACK = {
  url: 'usercenter/users/get_back',
  config: {
    method: 'post',
    host: 'usercenter',
    noWarn: true,
  },
};

/** 获取菜单*/
export const API_GET_SLIDER_MENUS_TREE = {
  // 用户中心 - 获取侧边栏菜单
  url: 'menus/permissions/menus',
  config: {
    method: 'get',
    host: 'usercenter',
  },
};
/** 获取供应商类型*/
export const API_GET_SUPPLIER_TYPE = {
  url: 'supplier/supplier/detail',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};
export const API_GET_BUSINESS_PERMISSIONS_CONFIG = {
  // 获取用户业务权限
  url: 'business',
  config: {
    method: 'get',
    host: 'usercenter',
  },
};

/** 测试菜单*/
export const API_GET_MENU = {
  url: 'menu/list',
  config: {
    method: 'get',
    host: 'CSXWMS',
  },
};

/** 获取按钮级别的用户权限*/
export const API_GET_USER_CENTER_PERMISSIONS_BANS = {
  url: 'menus/permissions/bans',
  config: {
    method: 'get',
    host: 'usercenter',
  },
};

export const API_POST_FEATURE_TOGGLE_STATUS = {
  url: 'devops-v1/devops/txSwitch2C/getSwitchStatus',
  config: {
    method: 'post',
    host: 'DEVOPS',
  },
};

// 获取来源类型
export const API_POST_PURCHASE_ORDER_SOURCE_TYPE_KEYVALUES = {
  url: 'purchase/order/source/type/keyvalues',
  config: {
    method: 'get',
    host: 'SCM',
  },
};

// 子客户
export const API_GET_LIKE_SELECT_SON_CUSTOMER_LIST = {
  url: 'like/select/son/customer/list',
  config: {
    method: 'get',
    host: 'SCM',
  },
};

/** 模糊查询客户*/
export const API_GET_LIKE_SELECT_CUSTOMER_LIST = {
  url: 'like/select/customer/list',
  config: {
    method: 'get',
    host: 'SCM',
  },
};

/** 出库单打印- 根据子客户编码集合获得合并模板列表*/
export const API_GET_PRINT_TMP_LIST_MERGE = {
  url: 'template/getTemplates',
  config: {
    method: 'get',
    host: 'MALIANG',
  },
};

// 获取主客户列表 - 新接口
export const API_MAIN_CUSTOMER_LIST = {
  url: 'dataSecureSearch/mall/search/main',
  config: {
    method: 'POST',
    host: 'NOT',
  },
};
// 获取子客户列表 - 新接口
export const API_SUB_CUSTOMER_LIST = {
  url: 'dataSecureSearch//mall/search/sub',
  config: {
    method: 'POST',
    host: 'NOT',
  },
};

/** 脱敏子客户 */
export const API_POST_MALL_SEARCH_SUB = {
  url: 'dataSecureSearch/mall/search/sub',
  config: {
    method: 'post',
    host: 'NOT',
  },
};
export const API_GET_FRONT_SHOW_ = {
  url: 'datasecure/front/show',
  config: {
    method: 'POST',
    host: 'NOT',
  },
};

// 冷环境检查 token
export const API_CHECKTOKEN = {
  url: 'login/check/token',
  config: {
    method: 'get',
    host: 'USERCENTER',
    noWarn: true,
  },
};
